class ClioTracking {
  constructor(options={}) {
    this.events = options.events || []
    this.user = options.user || false
    this.product = options.product || false
    this.template = options.template || false
    this.total = options.total || 0
    this.debug = options.debug || false
    this.init()
  }
  
  init() {
    window.dataLayer = window.dataLayer || []
    document.addEventListener("DOMContentLoaded", () => {
      this.events.forEach(event => {
        const eventFn = this['event' + event]
        if(typeof eventFn === 'function') { eventFn.call(this) }
      })
    })
  }
  
  sendEvent(event='', data=false) {
    if(this.debug) {
      console.log('🟢 ClioTracking - ' + event, data)
      if(this.debug?.preventEventSend === true) return
    }
    if(!data) return
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push(data)
  }
  
  maybePreventRefresh(e) {
    if(this.debug?.preventRefresh === true) { 
      e.preventDefault()
      e.stopPropagation()
    }
  }
  
  eventViewItemList() {
    const lists = document.querySelectorAll('[data-tracking-list]')
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          const list = entry.target
          this.sendEvent('ViewItemList', buildData(list))
          obs.unobserve(list)
        }
      })
    }, { threshold: 0.1 })
    let buildData = (list) => {
      const dataList = JSON.parse(list.dataset.trackingList)
      const dataItems = []
      let dataEvent = {
        event: 'view_item_list',
        ecommerce: dataList
      }
      const items = list.querySelectorAll('[data-tracking-product]')
      items.forEach((item, index) => {
        item.dataset.index = index
        dataItems.push({ ...dataList, ...{ index: index }, ...JSON.parse(item.dataset.trackingProduct) })
      })
      dataEvent.ecommerce.items = dataItems
      return dataEvent
    }
    lists.forEach((list, index) => {
      if(!index && this.template.startsWith('collection')) {
        this.sendEvent('ViewItemList', buildData(list))
      } else {
        observer.observe(list)
      }
    })
  }
  
  eventSelectItem() {
    if(this.template.startsWith('cart')) return
    const items = document.querySelectorAll('[data-tracking-product]')
    let selectedVariants = []
    items.forEach((item) => {
      item.addEventListener('click', () => {
        if(selectedVariants.includes(item.dataset.trackingVariant)) return
        const list = item.closest('[data-tracking-list]')
        let dataItem = JSON.parse(item.dataset.trackingProduct)
        const dataList = list ? JSON.parse(list.dataset.trackingList) : {}
        let dataEvent = {
          event: 'select_item',
          ecommerce: dataList
        }
        dataEvent.ecommerce.items = [{ ...dataList, ...{ index: parseInt(item.dataset.index) }, ...dataItem }]
        this.sendEvent('SelectItem', dataEvent)
        selectedVariants.push(item.dataset.trackingVariant)
      })
      const variantSelectors = item.querySelectorAll('.clio-palette-selector-new input, select.variant')
      variantSelectors.forEach(variantSelector => {
        variantSelector.addEventListener('change', () => {
          let dataItem = JSON.parse(item.dataset.trackingProduct)
          if(variantSelector instanceof HTMLSelectElement) {
            dataItem.variant_id = parseInt(variantSelector.value)
            dataItem.item_variant = variantSelector.options[variantSelector.selectedIndex].text
            dataItem.item_sku = variantSelector.options[variantSelector.selectedIndex].dataset.sku
          } else {
            dataItem.item_sku = variantSelector.dataset.sku
            dataItem.variant_id = parseInt(variantSelector.dataset.id)
            dataItem.item_variant = variantSelector.value
          }
          item.dataset.trackingProduct = JSON.stringify(dataItem)
          item.dataset.trackingVariant = dataItem.variant_id
          item.click()
        })
      })
    })
  }
  
  eventViewItem() {
    if(!this.template.startsWith('product') || !this.product) return
    let dataEvent = {
      event: 'view_item',
      ecommerce: {
        currency: "EUR",
        value: this.product.price,
        items: [ this.product ]
      }
    }
    this.sendEvent('ViewItem', dataEvent)
    
    window.addEventListener('trackingViewItem', (e) => {
      this.product.variant_id = e.detail.variant_id
      this.product.item_variant = e.detail.variant_name
      dataEvent.ecommerce.items = [ this.product ]
      this.sendEvent('ViewItem', dataEvent)
    })
  }
  
  eventProductInterest() {
    if(!this.template.startsWith('product') || !this.product) return
    let dataEvent = {
      event: 'product_interest',
      type: '',
      ecommerce: {
        items: [ this.product ]
      }
    }
    
    window.addEventListener('trackingProductInterest', (e) => {
      this.product.item_sku = e.detail.variant_sku
      this.product.variant_id = e.detail.variant_id
      this.product.item_variant = e.detail.variant_name
      dataEvent.type = e.detail.type
      dataEvent.ecommerce.items = [ this.product ]
      this.sendEvent('ProductInterest', dataEvent)
    })
  }
  
  eventSearchInteraction() {
    document.addEventListener('doofinder.layer.update', (() => {
      let timeout
      return (event) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          const search = document.querySelector('[name="search[query]"]')
          const results = document.querySelector('.dfd-meta strong')
          this.sendEvent('SearchInteraction', {
            event: 'search_interaction',
            search_term: search ? search.value : '',
            search_results: results ? parseInt(results.innerText) : ''
          })
        }, 1000)
      }
    })())
  }
  
  eventRegistration() {
    let dataEvent = { event: 'registration' }
    const consentStorage = localStorage.getItem('trackingRegister')
    if(this.template == 'customers/register') {
      const form = document.querySelector('#create_customer')
      if(form) { 
        form.addEventListener('submit', (e) => {
          this.maybePreventRefresh(e)
          let consents = []
          if(form.querySelector('#consent1-1').checked) consents.push('personalization')
          if(form.querySelector('#consent2-1').checked) consents.push('offers')
          if(form.querySelector('#consent3-1').checked) consents.push('marketing')
          dataEvent.consents = consents.join(',')
          dataEvent.step = 'start'
          localStorage.setItem('trackingRegister', dataEvent.consents)
          this.sendEvent('Registration', dataEvent)
        })
      }
    }
    if(consentStorage && this.user) {
      dataEvent.step = 'complete'
      dataEvent.consents = consentStorage
      this.sendEvent('Registration', dataEvent)
      localStorage.removeItem('trackingRegister')
    }
  }
  
  eventAddToCart() {
    let dataEvent = {
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: 0,
        items: []
      }
    }
    window.addEventListener('trackingAddToCart', (e) => {
      const variant_id = e.detail.variant_id
      const quantity = parseInt(e.detail.quantity)
      let list = {}
      let product = false
      if(this.product.variant_id == variant_id) {
        product = this.product
      } else {
        const productEl = document.querySelector(`[data-tracking-variant="${variant_id}"]`)
        if(productEl) { product = JSON.parse(productEl.dataset.trackingProduct) }
        const listEl = productEl.closest('[data-tracking-list]')
        if(listEl) {
          list = JSON.parse(listEl.dataset.trackingList)
          listEl.querySelectorAll('[data-tracking-variant]')?.forEach((el, index)=>{
            if(el == productEl) { list.index = index }
          })
        }
      }
      if(!product) return
      if(e.detail.index) { list.index = parseInt(e.detail.index) }
      dataEvent.ecommerce.items = [{ ...product, ...{ quantity: quantity }, ...list }]
      dataEvent.ecommerce.value = quantity * product.price
      this.sendEvent('AddToCart', dataEvent)
    })
  }
  
  eventViewCart() {
    if(!this.template.startsWith('cart')) return
    let dataEvent = {
      event: 'view_cart',
      ecommerce: {
        currency: 'EUR',
        value: this.total,
        items: []
      }
    }
    const items = document.querySelectorAll('.cart-table [data-tracking-product]')
    items.forEach((item, index) => {
      dataEvent.ecommerce.items.push({ ...{ index: index }, ...JSON.parse(item.dataset.trackingProduct) })
    })
    this.sendEvent('ViewCart', dataEvent)
  }
  
  eventRemoveFromCart() {
    if(!this.template.startsWith('cart')) return
    let dataEvent = {
      event: 'remove_from_cart',
      ecommerce: {
        currency: 'EUR',
        value: 0,
        items: []
      }
    }
    const items = document.querySelectorAll('.cart-table [data-tracking-product]')
    items.forEach((item, index) => {
      const button = item.querySelector('.remove a')
      button.addEventListener('click', (e) => {
        this.maybePreventRefresh(e)
        const product = JSON.parse(item.dataset.trackingProduct)
        dataEvent.ecommerce.items = [ { ...{ index: index }, ...product } ]
        dataEvent.ecommerce.value = product.quantity * product.price
        this.sendEvent('RemoveFromCart', dataEvent)
      })
    })
    window.addEventListener('trackingRemoveFromCart', (e) => {
      const variant_id = e.detail.variant_id
      const quantity = parseInt(e.detail.quantity)
      const index = parseInt(e.detail.index)
      const productEl = document.querySelector(`[data-tracking-variant="${variant_id}"]`)
      const product = JSON.parse(productEl.dataset.trackingProduct)
      product.quantity = quantity
      dataEvent.ecommerce.items = [ { ...{ index: index }, ...product } ]
      dataEvent.ecommerce.value = product.quantity * product.price
      this.sendEvent('RemoveFromCart', dataEvent)
    })
    const updateButtons = document.querySelectorAll('input[name="update"], button[name="checkout"]')
    updateButtons.forEach(updateButton => {
      updateButton.addEventListener('click', (e) => {
        this.maybePreventRefresh(e)
        items.forEach((item, index) => {
          const product = JSON.parse(item.dataset.trackingProduct)
          const oldQuantity = parseInt(product.quantity)
          const newQuantity = parseInt(item.querySelector('[name="updates[]"]').value)
          if(oldQuantity == newQuantity) return
          window.dispatchEvent(new CustomEvent(oldQuantity > newQuantity ? 'trackingRemoveFromCart' : 'trackingAddToCart', {
            detail: {
              variant_id: parseInt(product.variant_id),
              quantity: Math.abs(oldQuantity - newQuantity),
              index: index
            }
          }))
        })
      })
    })
  }
  
  eventLogin() {
    if(this.template == 'customers/login') {
      const form = document.querySelector('#customer_login')
      if(form) { form.addEventListener('submit', () => { localStorage.setItem('trackingLogin', true) }) }
    }
    if(localStorage.getItem('trackingLogin')) {
      if(this.user) {
        const dataEvent = {
          event: 'login',
          area: 'menu',
          user_id: this.user.id,
          user_properties: {
            email: this.user.email,
            phone: this.user.phone,
            name: this.user.name,
            surname: this.user.surname,
            country: this.user.country,
            zip_code: this.user.zip_code,
          }
        }
        this.sendEvent('Login', dataEvent)
      }
      localStorage.removeItem('trackingLogin')
    }
  }
  
  eventUserProperties() {
    if(!this.user) return
    const dataEvent = {
      event: 'user_properties',
      user_id: this.user.id,
      user_properties: {
        email: this.user.email,
        phone: this.user.phone,
        name: this.user.name,
        surname: this.user.surname,
        country: this.user.country,
        zip_code: this.user.zip_code,
      }
    }
    this.sendEvent('UserProperties', dataEvent)
  }
  
  eventFilterApplied() {
    const select = document.querySelector('select.sort-listbox')
    if(!select) return
    select.addEventListener('change', (e) => {
      this.maybePreventRefresh(e)
      let dataEvent = {
        event: 'filter_applied',
        type: 'ordina',
        select: select.options[select.selectedIndex].text
      }
      this.sendEvent('FilterApplied', dataEvent)
    })
  }
  
  eventStoreLocator() {
    window.addEventListener('trackingStoreLocator', (e) => {
      let dataEvent = {
        event: 'store_locator',
        type: e.detail.type,
        store_city: e.detail.city,
        store_address: e.detail.address, 
      }
      this.sendEvent('StoreLocator', dataEvent)
    })
  }
  
  eventMenuClick() {
    const links = document.querySelectorAll('header a, footer a')
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        this.maybePreventRefresh(e)
        const parent = link.closest('.js-has-submenu, [data-tracking-title]')
        const textLink = link.getAttribute('title') ?? link.innerText
        const textParent = parent ? (parent.dataset.trackingTitle ?? parent.firstElementChild.innerText) : textLink
        let dataEvent = {
          event: 'menu_click',
          type: link.closest('header') ? 'header' : 'footer',
          menu_text: textParent,
          submenu_text: textParent == textLink ? '' : textLink,
          link_url: link.href
        }
        this.sendEvent('MenuClick', dataEvent)
      })
    })
  }
  
  eventNewsletter() {
    window.addEventListener("klaviyoForms", (e) => { 
      if(e.detail.type == 'submit') { this.sendEvent('Newsletter', { event: 'newsletter_subscription' }) }
    })
  }
}
